import React from "react";

const AboutMeShimmer = () => {
  return (
    <div className="w-full flex justify-between items-center animate-pulse">
      {/* Left Section - Avatar and GitHub Info */}
      <div className="flex justify-center items-center flex-col lg:flex-row w-full">
        <div className="w-[220px] h-[220px] bg-gray-200 rounded-full my-2" />

        <div className="lg:ml-5 mt-4 lg:mt-0 text-left w-[60%] space-y-3">
          <div className="h-6 bg-gray-200 rounded w-[60%]" />
          <div className="h-4 bg-gray-200 rounded w-[40%]" />
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-4/5" />
        </div>
      </div>

      {/* Right Section - Social Icons */}
      <div className="flex flex-col justify-center gap-5 pt-5 font-bold text-lg pb-5">
        <div className="w-10 h-10 bg-gray-200 rounded-full" />
        <div className="w-10 h-10 bg-gray-200 rounded-full" />
        <div className="w-10 h-10 bg-gray-200 rounded-full" />
      </div>
    </div>
  );
};

export default AboutMeShimmer;
